module.exports = __webpack_public_path__ + "static/img/kjdy13.1ffab89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/kjdy13.png
// module id = 328
// module chunks = 0